export interface ContactInfo {
  /** Flaticon suffix, e.g. `phone-call`, `comment`, `location`. */
  icon: string
  title: string
  value: string
  /** Present for phone/email entries; omit for plain text like an address. */
  href?: string
}

export interface ContactInfosProps {
  items: ContactInfo[]
  className?: string
}

/**
 * The `.ul-contact-infos` row — phone, email, address, as icon cards.
 *
 * Every app has a page that opens with this row, and it was the same block in each. One
 * definition, in the system.
 */
export function ContactInfos({ items, className }: ContactInfosProps) {
  return (
    <div className={className ? `ul-contact-infos ${className}` : 'ul-contact-infos'}>
      <div className="ul-section-spacing ul-container">
        <div className="row row-cols-md-3 row-cols-2 row-cols-xxs-1 ul-bs-row">
          {items.map((info) => (
            <div className="col" key={info.title}>
              <div className="ul-contact-info">
                <div className="icon">
                  <i className={`flaticon-${info.icon}`} />
                </div>
                <div className="txt">
                  <span className="title">{info.title}</span>
                  {info.href ? <a href={info.href}>{info.value}</a> : <span className="descr">{info.value}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
